module.exports = __webpack_public_path__ + "img/success-send.62c17b75.png";